<div class="page-title d-flex align-items-start">
  <div>
    <p class="page-title__link-back"><a routerLink="/pre-process" i18n>Pré-processamento</a></p>
    <h2 i18n>Relatório de produção</h2>
  </div>
</div>

<div class="d-flex">
  <!-- <div class="d-flex mr-3">
    <button class="btn btn-fade-secondary btn-icon-block mr-2"><i class="material-icons">view_comfy</i></button>
    <button class="btn btn-fade-secondary btn-icon-block"><i class="material-icons">dehaze</i></button>
  </div> -->
  <div class="w-100">
    <input type="text" class="form-control form-search" [(ngModel)]="searchValue" placeholder="Buscar registro"
      (ngModelChange)="searchKey($event)">
  </div>
</div>
<app-enum-i18n [input]="violationSteps" (output)="setViolationStepsI18n($event)"></app-enum-i18n>
<div class="row pb-5" *ngIf="loading; else loadingBlock">
  <div class="col-12 col-sm-4 mt-4" *ngFor="let contract of filteredContractsList">
    <div class="card card-link">
      <!-- <button class="btn btn-fade-secondary btn-icon" (click)="updateCounters(contract)">
        <i class="material-icons" id="loadingRecount{{ contract.id }}">sync</i> Atualizar contadores
      </button> -->
      <a routerLink="{{ contract.id }}" class="text-dark no-hover">
        <div class="card-header">
          <p class="h5 mb-0">{{ contract.id }}</p>
          <p class="text-secondary mb-0">{{ contract.name }}</p>
        </div>
        <div class="card-body">
          <p class="mb-2" i18n>Hoje:</p>
          <div class="table-flex mb-4" *ngIf="loading; else loadingBlock">
            <div class="table-flex__header">
              <div class="w-100">
                <div class="table-flex__header__subColumns mb-0">
                  <p *ngIf="contract.steps && contract.steps.includes('triage')" i18n>Triagem</p>
                  <p *ngIf="contract.steps && contract.steps.includes('typing')" i18n>Digitação</p>
                  <p *ngIf="contract.steps && contract.steps.includes('verifyValid')" i18n>Verificação de válida</p>
                  <p *ngIf="contract.steps && contract.steps.includes('verifyInvalid')" i18n>Verificação de inválidas
                  </p>
                  <p *ngIf="contract.steps && contract.steps.includes('validate')" i18n>Validação</p>
                </div>
              </div>
            </div>
            <div class="table-flex__item">
              <div class="table-flex__row table-flex__row--sub-header">
                <div class="w-100 table-flex__header__subColumns mb-0 subColumns mt-0">
                  <div class="w-100 table-flex__item__subColumns">
                    <p *ngIf="contract.steps && contract.steps.includes('triage')">
                      {{ contract.today.triage }}
                    </p>
                    <p *ngIf="contract.steps && contract.steps.includes('typing')">
                      {{ contract.today.typing }}
                    </p>
                    <p *ngIf="contract.steps && contract.steps.includes('verifyValid')">
                      {{ contract.today.verifyValid }}
                    </p>
                    <p *ngIf="contract.steps && contract.steps.includes('verifyInvalid')">
                      {{ contract.today.verifyInvalid }}
                    </p>
                    <p *ngIf="contract.steps && contract.steps.includes('validate')">
                      {{ contract.today.validate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <p class="mb-2" i18n>Últimos 7 dias:</p>
          <div class="table-flex mb-4" *ngIf="loading; else loadingBlock">
            <div class="table-flex__header">
              <div class="w-100">
                <div class="table-flex__header__subColumns mb-0">
                  <p *ngIf="contract.steps && contract.steps.includes('triage')" i18n>Triagem</p>
                  <p *ngIf="contract.steps && contract.steps.includes('typing')" i18n>Digitação</p>
                  <p *ngIf="contract.steps && contract.steps.includes('verifyValid')" i18n>Verificação de válida</p>
                  <p *ngIf="contract.steps && contract.steps.includes('verifyInvalid')" i18n>Verificação de inválidas
                  </p>
                  <p *ngIf="contract.steps && contract.steps.includes('validate')" i18n>Validação</p>
                </div>
              </div>
            </div>

            <div class="table-flex__item">
              <div class="table-flex__row table-flex__row--sub-header">
                <div class="w-100 table-flex__item__subColumns">
                  <p *ngIf="contract.steps && contract.steps.includes('triage')">
                    {{ contract.triage }}
                  </p>
                  <p *ngIf="contract.steps && contract.steps.includes('typing')">
                    {{ contract.typing }}
                  </p>

                  <p *ngIf="contract.steps && contract.steps.includes('verifyValid')">
                    {{ contract.verifyValid }}
                  </p>

                  <p *ngIf="contract.steps && contract.steps.includes('verifyInvalid')">
                    {{ contract.verifyInvalid }}
                  </p>

                  <p *ngIf="contract.steps && contract.steps.includes('validate')">
                    {{ contract.validate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="mr-5">
              <p i18n class="mb-0"><small class="d-block">Total de horas trabalhadas</small></p>
              <p class="fs-1 mb-0">{{ setTime(contract.timeWorked) }}</p>
            </div>

            <div>
              <p i18n class="mb-0"><small class="d-block">Média por registro</small></p>
              <p class="fs-1 mb-0">{{ setTime(contract.timeWorked / contract.totalWork) }}</p>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>

<ng-template #loadingBlock>
  <div class="loading-page">
    <div class="loading-spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</ng-template>
